const STORAGE_PREFIX = 'pixie-suppress-alert-';

const NAV_ALERT_IDS = {
  telemetry: 'chatbot-telemetry',
  pollingLocks: 'polling-locks',
  rentMe: 'rent-me',
};

function getStorage(storage) {
  if (storage) return storage;
  try {
    if (typeof localStorage !== 'undefined') return localStorage;
  } catch (_) {
    /* ignore */
  }
  return null;
}

function alertSuppressKey(alertId) {
  return `${STORAGE_PREFIX}${alertId}`;
}

function isAlertAlwaysIgnored(alertId, storage) {
  const s = getStorage(storage);
  if (!s) return false;
  try {
    return s.getItem(alertSuppressKey(alertId)) === '1';
  } catch (_) {
    return false;
  }
}

function setAlertAlwaysIgnored(alertId, storage) {
  const s = getStorage(storage);
  if (!s) return;
  try {
    s.setItem(alertSuppressKey(alertId), '1');
  } catch (_) {
    /* quota / private mode */
  }
}

function shouldShowNavAlert(alertId, storage) {
  return !isAlertAlwaysIgnored(alertId, storage);
}

module.exports = {
  NAV_ALERT_IDS,
  alertSuppressKey,
  isAlertAlwaysIgnored,
  setAlertAlwaysIgnored,
  shouldShowNavAlert,
};
